import auth from '@/api/auth'
import { notify } from '@/utils/error'
import router from '@/router/index'

export default {
  namespaced: true,

  state: {
    jwt: localStorage.getItem('jwt'),
    refreshToken: localStorage.getItem('refreshToken'),
    userId: localStorage.getItem('userId'),
    masterJwt: localStorage.getItem('masterJwt'),
    masterUserId: localStorage.getItem('masterUserId'),
    lastActive: localStorage.getItem('lastActive'),
    rememberMe: localStorage.getItem('rememberMe'),
    identityTaken: false
  },

  getters: {
    user (state, getters, rootState) {
      return state.userId ? rootState.users.items[state.userId] : null
    },
    childCompanyUserIsTaken (state) {
      return state.jwt && state.masterJwt
    }
  },

  actions: {
    signInWithEmailAndPassword ({ commit, dispatch }, { username, password }) {
      return new Promise((resolve, reject) => {
        auth.login({ username, password })
          .then(response => {
            const userId = response.data.items[0].user_account
            const jwt = response.data.items[0].token
            const refreshToken = response.data.items[0].refresh_token
            commit('emptyMaster')
            commit('setJwt', jwt)
            commit('setRefreshToken', refreshToken)
            commit('setUserId', userId)
            dispatch('loadUser')
              .then(user => {
                commit('setLastActive', Date.now())
                resolve()
              })
              .catch(error => {
                notify(error)
                reject(error)
              })
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },

    loadUser ({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('users/loadItem', state.userId, { root: true })
          .then(user => {
            resolve(user)
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },

    signOut ({ commit }) {
      return new Promise((resolve, reject) => {
        auth.logout()
          .then(response => {
            commit('setJwt', null)
            commit('setRefreshToken', null)
            commit('setUserId', null)
            commit('emptyMaster')
            commit('setLastActive', null)
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    },

    forceSignOut ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('setJwt', null)
        commit('setRefreshToken', null)
        commit('setUserId', null)
        commit('emptyMaster')
        commit('setLastActive', null)
        resolve()
      })
    },

    endIdentity ({ state, commit }) {
      return new Promise((resolve, reject) => {
        if (!state.masterJwt) {
          resolve()
        } else {
          commit('setJwt', state.masterJwt)
          commit('setUserId', state.masterUserId)
          commit('emptyMaster')
          commit('setIdentityState', false)
          commit('businessUnits/setCurrent', null, { root: true })
          resolve()
        }
      })
    },

    tryAutoLogout ({ state, commit, dispatch }) {
      return new Promise((resolve, reject) => {
        if (state.rememberMe) {
          resolve()
        } else {
          if (state.lastActive) {
            const now = Date.now()
            const timeChange = now - state.lastActive
            if (timeChange > 1000 * 60 * 15) {
              dispatch('signOut')
                .then(() => {
                  router.push({ name: 'Login' })
                })
              reject(new Error('session ended'))
            }
          }
          commit('setLastActive', Date.now())
        }
        resolve()
      })
    },

    updateRememberMe ({ commit }, rememberMe) {
      return new Promise((resolve, reject) => {
        commit('setRememberMe', rememberMe)
        resolve()
      })
    }
  },

  mutations: {
    setJwt (state, jwt) {
      jwt ? localStorage.setItem('jwt', jwt) : localStorage.removeItem('jwt')
      state.jwt = jwt
    },
    setRefreshToken (state, refreshToken) {
      refreshToken ? localStorage.setItem('refreshToken', refreshToken) : localStorage.removeItem('refreshToken')
      state.refreshToken = refreshToken
    },
    setUserId (state, userId) {
      userId ? localStorage.setItem('userId', userId) : localStorage.removeItem('userId')
      state.userId = userId
    },
    setMaster (state) {
      localStorage.setItem('masterJwt', state.jwt)
      state.masterJwt = state.jwt
      localStorage.setItem('masterUserId', state.userId)
      state.masterUserId = state.userId
    },
    setIdentityState (state, identityTaken) {
      state.identityTaken = identityTaken
    },
    emptyMaster (state) {
      localStorage.removeItem('masterJwt')
      state.masterJwt = null
      localStorage.removeItem('masterUserId')
      state.masterUserId = null
    },
    setLastActive (state, lastActive) {
      lastActive ? localStorage.setItem('lastActive', lastActive) : localStorage.removeItem('lastActive')
      state.lastActive = lastActive
    },
    setRememberMe (state, rememberMe) {
      rememberMe ? localStorage.setItem('rememberMe', rememberMe) : localStorage.removeItem('rememberMe')
      state.rememberMe = rememberMe
    }
  }
}
